import { ShoppingCart } from '@carbon/icons-react';
import { Route } from 'react-router';
import type { NavGroup } from '../AdminShell';
import { ORDER_PERMISSIONS, ORDER_READ_PERMISSION, type OrdersMode } from './model';
import { OrderGuard as Guard } from './OrderGuard';
import { CreateOrderPage } from './CreateOrderPage';
import { OrderDetailPage } from './OrderDetailPage';
import { OrdersPage } from './OrdersPage';
import { PaymentHistoryPage } from './PaymentHistoryPage';
import { PaymentTransactionsPage } from './PaymentTransactionsPage';
import { ShippingHistoryPage } from './ShippingHistoryPage';
import { ShippingTransactionsPage } from './ShippingTransactionsPage';

/** The side nav group for orders, payment and shipping transactions, shown to users who can read orders. */
export function salesNav(mode: OrdersMode): NavGroup {
  const permission = ORDER_READ_PERMISSION[mode];
  return {
    label: 'admin.nav.sales',
    icon: ShoppingCart,
    items: [
      { label: 'admin.nav.orders', path: '/orders', permission },
      { label: 'admin.nav.payments', path: '/sales/payments', permission },
      { label: 'admin.nav.shipping', path: '/sales/shipping', permission },
    ],
  };
}

/** Order, payment and shipping screens; creating orders only at the store. Use inside <Routes>. */
export function orderRoutes(mode: OrdersMode) {
  const read = ORDER_READ_PERMISSION[mode];
  return [
    <Route key="orders" path="/orders" element={<Guard permission={read}><OrdersPage mode={mode} /></Guard>} />,
    ...(mode === 'store'
      ? [<Route key="orders-new" path="/orders/new" element={<Guard permission={ORDER_PERMISSIONS.manage}><CreateOrderPage /></Guard>} />]
      : []),
    <Route key="payments" path="/sales/payments" element={<Guard permission={read}><PaymentTransactionsPage mode={mode} /></Guard>} />,
    <Route key="shipping" path="/sales/shipping" element={<Guard permission={read}><ShippingTransactionsPage mode={mode} /></Guard>} />,
    <Route key="payment" path="/sales/payments/:id" element={<Guard permission={read}><PaymentHistoryPage mode={mode} /></Guard>} />,
    <Route key="delivery" path="/sales/shipping/:id" element={<Guard permission={read}><ShippingHistoryPage mode={mode} /></Guard>} />,
    <Route key="order" path="/orders/:id" element={<Guard permission={read}><OrderDetailPage mode={mode} /></Guard>} />,
  ];
}
